var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FFEEE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0142 18.4348V14.0521C9.0142 13.4782 8.54464 13.0087 7.97072 13.0087C7.39681 13.0087 6.92725 13.4782 6.92725 14.0521V18.4348C6.92725 19.0087 7.39681 19.4782 7.97072 19.4782C8.54464 19.4782 9.0142 19.0087 9.0142 18.4348Z",
    fill: "#FAA037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3187 18.4348C16.3187 19.0087 16.7883 19.4782 17.3622 19.4782C17.9361 19.4782 18.4057 19.0087 18.4057 18.4348V5.56521C18.4057 4.99129 17.9361 4.52173 17.3622 4.52173C16.7883 4.52173 16.3187 4.99129 16.3187 5.56521V18.4348Z",
    fill: "#FFC9A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 9.80868V18.4348C13.71 19.0087 13.2404 19.4782 12.6665 19.4782C12.0926 19.4782 11.623 19.0087 11.623 18.4348V9.80868C11.623 9.23477 12.0926 8.76521 12.6665 8.76521C13.2404 8.76521 13.71 9.23477 13.71 9.80868Z",
    fill: "#FFC9A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.8a2ab4f69cf1dbc53485611fe19e3f6a.svg";
export { ForwardRef as ReactComponent };